export const TRANSLATION_STORIES_LIST = {
  header: {
    heroTitle: 'global.stories_plural',
    button: 'stories.header.new_story'
  },
  filterButton: 'global.button.filter',
  table: {
    header: {
      title: 'csp.title',
      author: 'csp.author',
      type: 'csp.type',
      dateFrom: 'csp.start_date',
      dateEnd: 'csp.final_date',
      state: 'csp.status',
      actions: 'csp.action_plural'
    },
    filter: {
      all: 'csp.all_female',
      visible: 'csp.visible_plural',
      hidden: 'csp.hidden_plural',
      scheduled: 'csp.scheduled_plural',
      permanent: 'csp.permanent_plural'
    },
    state: {
      visible: 'csp.visible',
      hidden: 'csp.hidden',
      scheduled: 'csp.scheduled',
      permanent: 'csp.permanent'
    },
    type: {
      all: 'csp.all_female',
      static: 'csp.image',
      video: 'csp.video'
    },
    tooltip: {
      details: 'tooltip.stories_list.see_details',
      duplicate: 'tooltip.stories_list.duplicate_story',
      hide: 'tooltip.stories_list.hide_story'
    }
  },
  search: {
    detail: 'csp.searcher_stories',
    mobile: 'csp.search'
  },
  error: {
    title: 'csp.loading_error.title',
    subtitle: 'csp.empty_state.subtitle',
    buttonText: 'button.retry'
  },
  noStories: {
    title: 'stories_list.no_stories.title',
    subtitle: 'stories_list.no_stories.description',
    buttonText: 'stories_list.no_stories.create_new_story'
  },
  modal: {
    hideStory: {
      title: 'stories_list.modal.hide_story.title',
      description: 'stories_list.modal.hide_story.description',
      primaryButton: 'Ocultar story',
      secondaryButton: 'button.cancel'
    },
    storyDetail: {
      title: 'stories_list.modal.story_details.title',
      description: 'stories_list.modal.story_details.description',
      author: 'csp.author',
      type: 'csp.type',
      dateFrom: 'csp.start_date',
      dateEnd: 'csp.final_date',
      state: 'csp.status',
      button: 'button.ready',
      views: 'stories_list.modal.story_details.views'
    },
    storyDetailError: {
      title: 'csp.loading_error.title',
      subtitle: 'csp.empty_state.subtitle',
      buttonText: 'button.understood'
    }
  }
};

export const TRANSLATION_STORIES_CREATE_NEW = {
  header: {
    pagename: 'new_story.page',
    heroDescription: 'new_story.hero.description'
  },
  form: {
    labelFile: 'new_story.form.label_file',
    labelTitle: 'new_story.form.label_title',
    placeholderTitle: 'new_story.form.placeholder_title',
    labelDates: 'new_story.form.label_dates',
    checkbox: 'new_story.form.checkbox',
    cardStatus: 'new_story.form.card_status',
    cardStatusWarning: 'new_story.form.card_status_warning',
    placeholderStartDate: 'new_story.form.placeholder_start_date',
    placeholderEndDate: 'new_story.form.placeholder_end_date',
    cancelButton: 'new_story.form.cancel_button',
    publishButton: 'new_story.form.publish_button',
    titleFileInput: 'new_story.form.title_file_input',
    subtitleFileInput: 'new_story.form.subtitle_file_input',
    placeholderFileInput: 'new_story.form.placeholder_file_input',
    titleUploading: 'new_story.form.title_uploading',
    subtitleUploading: 'new_story.form.subtitle_uploading',
    editButtonPreview: 'new_story.form.edit_button_preview',
    deleteButtonPreview: 'new_story.form.delete_button_preview'
  },
  publishModal: {
    title: 'new_story.publish_modal.title',
    subtitle: 'new_story.publish_modal.subtitle',
    button: 'new_story.publish_modal.button'
  },
  programModal: {
    title: 'new_story.program_modal.title',
    subtitle: 'new_story.program_modal.subtitle',
    button: 'new_story.program_modal.button'
  },
  toasts: {
    publishSuccess: {
      title: 'new_story.toast.publish_success.title',
      description: 'new_story.toast.publish_success.description'
    },
    publishError: {
      title: 'new_story.toast.publish_error.title',
      description: 'new_story.toast.publish_error.description'
    },
    programSuccess: {
      title: 'new_story.toast.program_success.title',
      description: 'new_story.toast.program_success.description'
    },
    uploadError: {
      title: 'new_story.toast.upload_error.title',
      description: 'new_story.toast.upload_error.description'
    },
    uploadServiceError: {
      title: 'new_story.toast.upload_service_error.title',
      description: 'new_story.toast.upload_service_error.description'
    },
    invalidFormatError: {
      title: 'new_story.toast.invalid_format_error.title',
      description: 'new_story.toast.invalid_format_error.description'
    },
    maxSizeImgError: {
      title: 'new_story.toast.max_size_img_error.title',
      description: 'new_story.toast.max_size_img_error.description'
    },
    maxSizeVideoError: {
      title: 'new_story.toast.max_size_video_error.title',
      description: 'new_story.toast.max_size_video_error.description'
    },
    buttonText: 'button.accept'
  }
};
